module.exports = {"650105001":"水磨沟街道","650105002":"六道湾街道","650105003":"苇湖梁街道","650105004":"八道湾街道","650105005":"新民路街道","650105006":"南湖南路街道","650105007":"南湖北路街道","650105008":"七道湾街道","650105010":"榆树沟街道","650105011":"石人子沟街道","650105012":"水塔山街道","650105013":"华光街街道","650105014":"龙盛街街道","650105015":"振安街街道","650105016":"河马泉街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650105.json
// module id = 3192
// module chunks = 0